
import * as angular from "angular";
import { ParagonImportAdapterService } from "src/app/main/components/csvImporter/adapters/paragonImportAdapter.service";
import { CsvImporterService } from "./csvImporter.service";
import { GeofenceImporterService } from "./geofenceImporter/geofenceImporter.service";

angular
    .module("app.components.csvImporter", [])
    .service("csvImporterService", CsvImporterService)
    .service("geofenceImporterService", GeofenceImporterService)
    .service("paragonImportAdapterService", ParagonImportAdapterService)
